import { ActionContext } from "vuex"

export interface ItemSearchQuery {
  cat: number[] | undefined;
  l: string[] | undefined;
  d: string[] | undefined;
  s: undefined;
}

export interface UrlState {
  itemSearchQuery: ItemSearchQuery | undefined;
}
export default {
  namespaced: true,
  state: (): UrlState => ({
    itemSearchQuery: undefined,
  }),
  mutations: {
    setItemSearchQuery (
      state: UrlState,
      itemSearchQuery: ItemSearchQuery | undefined
    ) {
      state.itemSearchQuery = itemSearchQuery
    },
  },
  getters: {
    itemSearchQuery: (state: UrlState) => state.itemSearchQuery
  },
  actions: {
    setItemSearchQuery (context: ActionContext<UrlState, {}>, payload: ItemSearchQuery | undefined) {
      context.commit('setItemSearchQuery', payload)
    },
  }
}
